import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import PlatformUserSpecialties from '@/types/table/platformUserSpecialties';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface PlatformUserSpecialtiesData extends PlatformUserSpecialties {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class PlatformUserSpecialtiesController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PlatformUserSpecialtiesData>>(API_CONTEXT + '/app/platformUserSpecialties/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<PlatformUserSpecialtiesData>(API_CONTEXT + '/app/platformUserSpecialties/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/platformUserSpecialties/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/platformUserSpecialties/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/platformUserSpecialties/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserSpecialties/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserSpecialties/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserSpecialties/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserSpecialties/deleteBatch', params, httpOptions);
  }
}
